/**
 * Hotels tab uses Hubwayz only when VITE_HUBWAYZ_HOTELS_TAB=1.
 * Unset keeps the existing hotels search. Packages and flights are unchanged.
 */
export function isHubwayzHotelsTabEnabled(env = import.meta.env) {
  return String(env?.VITE_HUBWAYZ_HOTELS_TAB || "") === "1";
}

export const HUBWAYZ_HOTELS_TAB_ENABLED = isHubwayzHotelsTabEnabled();

export const HUBWAYZ_HOTELS_TAB_SNAPSHOT_KEY = "hubwayzHotelsTabSnapshot_v1";

export const HUBWAYZ_HOTEL_ID_PREFIX = "hwz-";

export function isHubwayzHotelSearchResult(item) {
  if (!item || typeof item !== "object") return false;
  if (item._supplier === "hubwayz" || item.provider === "hubwayz") return true;
  const id = String(item.ID ?? item.id ?? "");
  return id.startsWith(HUBWAYZ_HOTEL_ID_PREFIX);
}

export function hubwayzHotelIdFromResult(item) {
  if (!item) return null;
  if (item.hubwayzHotelId != null) return String(item.hubwayzHotelId);
  const id = String(item.ID ?? item.id ?? "");
  if (id.startsWith(HUBWAYZ_HOTEL_ID_PREFIX)) {
    return id.slice(HUBWAYZ_HOTEL_ID_PREFIX.length);
  }
  return null;
}

export function hubwayzHotelProfilePath(hotelId) {
  const id = String(hotelId || "").replace(new RegExp(`^${HUBWAYZ_HOTEL_ID_PREFIX}`), "");
  if (!id) return "/p/dashboard/searchoffer";
  return `/p/dashboard/hotel/${encodeURIComponent(id)}`;
}
